namespace e5 {
    export class BaseVideo extends AbstractVideo {
        protected _video: HTMLVideoElement;

        constructor() {
            super();

            this.element = document.createElement("div");
            this.element.className = "e5-video base-video";
            this.element.innerHTML = `
            <video class="e5-video__video"></video>
            `;
            this._video = this.element.querySelector("video");

            this._video.addEventListener("timeupdate", () => {
                this.onTimeChange.dispatch(this._video.currentTime);
            });

            this._video.addEventListener("playing", () => {
                this.updateState(VideoPlayerState.PLAYING);
            });

            this._video.addEventListener("pause", () => {
                this.updateState(VideoPlayerState.PAUSED);
            });

            this._video.addEventListener("ended", () => {
                this.updateState(VideoPlayerState.ENDED);
            });

            this._video.addEventListener("waiting", () => {
                this.updateState(VideoPlayerState.BUFFERING);
            });

            this._video.addEventListener("durationchange", () => {
                this.onDurationChange.dispatch(this._video.duration);
                this.onReady.dispatch();
            });

            setInterval(() => {
                var buffer = this._video.buffered.length > 0 ? this._video.buffered.end(this._video.buffered.length - 1) / this._video.duration : 0;
                buffer = Calc.clamp(buffer, 0, 1);
                if (this.buffer != buffer) {
                    this.onBufferChange.dispatch(buffer);
                }
            }, 500);
        }

        private updateState(state: VideoPlayerState): void {

            // var state: VideoPlayerState = VideoPlayerState.UNSTARTED;

            // this._video.readyState

            // if (this._video.paused) {
            //     state = VideoPlayerState.PAUSED;
            // } else if (this._video.buffered) {

            // }

            // console.log("STATE", VideoPlayerState[state]);

            if (state != this.state) {
                this.onStateChange.dispatch(state);
            }
        }

        public load(src: string): void {
            this._video.src = src;
            this._video.load();
        }

        public play(): void {
            this._video.play();
        }

        public pause(): void {
            this._video.pause();
        }

        public seek(time: number): void {
            this._video.currentTime = time;
        }

        public dispose(): void {
            super.dispose();
        }
    }
}